import { useState } from "react";
import { Trash2 } from "lucide-react";
import { errMsg, inputCls } from "@/lib/scoring";

const time = (iso) => new Date(iso).toLocaleTimeString("en-US", { timeZone: "America/Chicago", hour: "numeric", minute: "2-digit", second: "2-digit" });

export function DetailsEditor({ api, s, onSaved }) {
  const [f, setF] = useState({ name: s.name, date: s.date, age_group: s.age_group || "" });
  const [msg, setMsg] = useState("");
  const save = async () => { setMsg(""); try { onSaved(await api.put(`/admin/scoring/sessions/${s.id}`, f)); setMsg("Saved — stats recalculated."); } catch (e) { setMsg(errMsg(e)); } };
  return (
    <div data-testid="details-editor" className="rounded-2xl border border-slate-200 bg-white p-4 space-y-3">
      <p className="text-xs font-bold uppercase tracking-wider text-slate-400">Session details</p>
      <div className="grid sm:grid-cols-3 gap-2">
        <input data-testid="edit-session-name" value={f.name} onChange={(e) => setF({ ...f, name: e.target.value })} className={inputCls} />
        <input data-testid="edit-session-date" type="date" value={f.date} onChange={(e) => setF({ ...f, date: e.target.value })} className={inputCls} />
        <select data-testid="edit-session-age" value={f.age_group} onChange={(e) => setF({ ...f, age_group: e.target.value })} className={inputCls}><option value="">No age group</option><option>13U & Under</option><option>14U & Up</option></select>
      </div>
      <div className="flex items-center gap-3"><button data-testid="save-session-details" onClick={save} className="rounded-full bg-[#0B0F19] px-5 py-2 text-sm font-bold text-white">Save details</button>{msg && <span data-testid="details-msg" className="text-sm text-slate-600">{msg}</span>}</div>
    </div>
  );
}

// Score list; admins correcting a completed session can change any result or remove it.
export function EventList({ api, s, outcomes, canEdit, correcting, act }) {
  const rows = correcting ? s.events : s.events.slice(0, 12);
  return (
    <div data-testid="recent-events" className="rounded-2xl border border-slate-200 bg-white p-4">
      <p className="text-xs font-bold uppercase tracking-wider text-slate-400 mb-2">{correcting ? `All scores (${s.events.length})` : "Recent scores"}</p>
      {!s.events.length && <p className="text-sm text-slate-400">No scores yet.</p>}
      {rows.map((e) => (
        <div key={e.id} data-testid={`event-${e.id}`} className="flex items-center gap-3 py-2 border-t border-slate-100 text-sm">
          <span className="text-slate-400 text-xs w-20 shrink-0">{time(e.at)}</span>
          <span className="flex-1 min-w-0 text-[#0B0F19] break-words">{e.player_name}{!correcting && ` · ${e.label}`}</span>
          {correcting ? (
            <select data-testid={`event-outcome-${e.id}`} value={e.outcome} onChange={(ev) => act(() => api.put(`/admin/scoring/sessions/${s.id}/events/${e.id}`, { outcome: ev.target.value }))} className="rounded-lg border border-slate-200 px-2 py-1 text-sm">
              {outcomes.map((o) => <option key={o.key} value={o.key}>{o.label} (+{o.points})</option>)}
            </select>
          ) : <span className="font-bold text-[#2563EB]">+{e.points}</span>}
          {canEdit && <button data-testid={`remove-event-${e.id}`} onClick={() => act(() => api.del(`/scoring/sessions/${s.id}/events/${e.id}`))} className="text-slate-400 hover:text-red-600" aria-label="Remove score"><Trash2 size={15} /></button>}
        </div>
      ))}
    </div>
  );
}
